module.exports = ".intro{\r\n    text-align: center;\r\n}\r\n\r\n.intro a{\r\n    color: initial;\r\n}\r\n\r\n.excercise {\r\n    border: 1px solid gray;\r\n    padding: 1.5em 0.7em;\r\n    margin: 1.5em 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main